export default {
	//发票、单据状态
	djzt: [{
			value: '-1',
			label: '草稿'
		},
		{
			value: '0',
			label: '待审核'
		},
		{
			value: '1',
			label: '已审核'
		},
		{
			value: '2',
			label: '待开票'
		},
		{
			value: '3',
			label: '开票中'
		},
		{
			value: '4',
			label: '已开票'
		},
		{
			value: '5',
			label: '已作废'
		},
		{
			value: '6',
			label: '已红冲'
		},
		{
			value: '7',
			label: '开票失败'
		},
		{
			value: '8',
			label: '暂不开票'
		},
		{
			value: '9',
			label: '已退票'
		},
		{
			value: '10',
			label: '已合并'
		},
		{
			value: '21',
			label: '作废关闭中'
		},
		{
			value: '22',
			label: '作废重开中'
		},
		{
			value: '23',
			label: '作废锁定(作废重开后的已作废状态)'
		},
		{
			value: '31',
			label: '未开发票冲销'
		},
		{
			value: '32',
			label: '已开发票冲销'
		},
		{
			value: '33',
			label: '作废冲销'
		},
		{
			value: '35',
			label: '待作废'
		},
		{
			value: '36',
			label: '审核拒绝'
		},
	],
	//单据来源
	djly: [{
			value: '1',
			label: '文件导入'
		},
		{
			value: '2',
			label: '手工录入'
		},
		{
			value: '3',
			label: '客户接口'
		},
		{
			value: '4',
			label: '税控同步'
		},
		{
			value: '5',
			label: '支付开票'
		},
		{
			value: '6',
			label: '扫码开票'
		},
		{
			value: '7',
			label: '红冲重开'
		},
		{
			value: '8',
			label: '作废重开'
		},
	],
	//特殊业务/特定业务类型
	tsyw: [{
			value: '01',
			label: '成品油'
		},
		{
			value: '02',
			label: '稀土'
		},
		{
			value: '03',
			label: '建筑服务'
		},
		{
			value: '04',
			label: '货物运输'
		},
		{
			value: '05',
			label: '不动产销售'
		},
		{
			value: '06',
			label: '不动产经营租赁'
		},
		{
			value: '07',
			label: '代收车船使用税'
		},
		{
			value: '08',
			label: '通行费'
		},
		{
			value: '09',
			label: '旅客运输'
		},
		{
			value: '10',
			label: '医疗服务'
		},
		{
			value: '11',
			label: '农产品'
		},
		{
			value: '12',
			label: '拖拉机和联合收割机'
		},
		{
			value: '13',
			label: '机动车'
		},
		{
			value: '14',
			label: '光伏收购'
		},
		{
			value: '15',
			label: '卷烟'
		},
	],
	//发票类型
	fplx: [{
			value: '004',
			label: '专票'
		},
		{
			value: '007',
			label: '普票'
		},
		{
			value: '025',
			label: '卷式发票'
		},
		{
			value: '005',
			label: '机动车发票'
		},
		{
			value: '008',
			label: '运输普票'
		},
		{
			value: '009',
			label: '运输专票'
		}, {
			value: '010',
			label: '定额发票'
		},
		{
			value: '011',
			label: '过路桥费'
		},
		{
			value: '222',
			label: '收据'
		},
		{
			value: '026',
			label: '电子发票(普票)'
		},
		{
			value: '028',
			label: '电子发票(专票)'
		},
		{
			value: '223',
			label: '形式发票'
		},
		{
			value: '224',
			label: '海关电子发票'
		},
		{
			value: '225',
			label: '增值税电子专票'
		}
	],
	//是否
	issf: [{
			value: '1',
			label: '是'
		},
		{
			value: '0',
			label: '否'
		}
	],
	//面积单位
	mjdw: [{
		value: '平方米',
		label: '平方米'
	}, {
		value: '亩',
		label: '亩'
	}, {
		value: '㎡',
		label: '㎡'
	}, {
		value: '平方千米',
		label: '平方千米'
	}, {
		value: '公顷',
		label: '公顷'
	}, {
		value: 'hm²',
		label: 'hm²'
	}, {
		value: 'km²',
		label: 'km²'
	}],
	lqfplx: [{
			name: "电子专票",
			code: "028"
		},
		{
			name: "纸质专票",
			code: "004"
		},
		{
			name: "纸质普票",
			code: "007"
		},
		{
			name: "电子普票",
			code: "026"
		}
	],
	lqdsrwStatus: [{
			name: "未启动",
			code: "0",
			color: "#666666"
		},
		{
			name: "启动成功",
			code: "2",
			color: "#0065B1"
		},
		{
			name: "启动中",
			code: "1",
			color: "#F29600"
		},
		{
			name: "启动失败",
			code: "-1",
			color: "#E02020"
		},
	],
	lqdjzt: [{
			name: "待审核",
			code: "0",
		},
		{
			name: "已审核",
			code: "1"
		},
		{
			name: "待开票",
			code: "2"
		},
		{
			name: "开票中",
			code: "3"
		},
		{
			name: "已开票",
			code: "4",
			color: "#0065B1"
		},
		{
			name: "已作废",
			code: "5"
		},
		{
			name: "已红冲",
			code: "6",
			color: "#E02020"
		},
		{
			name: "开票失败",
			code: "7",
			color: "#666666"
		},
		{
			name: "暂不开票",
			code: "8"
		},
		{
			name: "已退票",
			code: "9"
		},
		{
			name: "无需开票",
			code: "34"
		}
	],
	TaxpayerStatusOfDrawingParty: [{
			value: '01',
			label: '受理'
		},
		{
			value: '02',
			label: '筹建期'
		},
		{
			value: '03',
			label: '正常'
		},
		{
			value: '04',
			label: '停业'
		},
		{
			value: '05',
			label: '非正常'
		},
		{
			value: '06',
			label: '清算'
		},
		{
			value: '07',
			label: '注销'
		},
		{
			value: '08',
			label: '非正常户注销'
		},
		{
			value: '09',
			label: '报验'
		},
		{
			value: '10',
			label: '核销报验'
		},
		{
			value: '11',
			label: '中断缴费'
		},
		{
			value: '12',
			label: '恢复缴费'
		},
		{
			value: '13',
			label: '简易注销无异议'
		},
		{
			value: '99',
			label: '其他'
		}
	],
	TaxpayerType: [{
			value: '1',
			label: '一般纳税人'
		},
		{
			value: '2',
			label: '小规模纳税人'
		},
		{
			value: '3',
			label: '转登记小规模纳税人'
		},
		{
			value: '4',
			label: '辅导期一般纳税人'
		},
		{
			value: '5',
			label: '自然人'
		},
	],
	TotalMechanismType: [{
			value: '0',
			label: '非总分机构'
		},
		{
			value: '1',
			label: '总机构'
		},
		{
			value: '2',
			label: '分支机构'
		},
		{
			value: '3',
			label: '分总机构'
		},

	],
	ClassificationEnterprises: [{
			value: '',
			label: '非出口企业'
		},
		{
			value: '01',
			label: '一类出口企业'
		},
		{
			value: '02',
			label: '二类出口企业'
		},
		{
			value: '03',
			label: '三类出口企业'
		}, {
			value: '03',
			label: '四类出口企业'
		},

	],
	IndustryNatureOfEnterprise: [{
			value: '01',
			label: '成品油生产企业'
		},
		{
			value: '02',
			label: '成品油经销企业'
		},
		{
			value: '03',
			label: '国内机动车生产企业'
		},
		{
			value: '04',
			label: '进口机动车生产企业驻我国办事机构或总授权代理机构'
		},
		{
			value: '05',
			label: '机动车授权经销企业'
		},
		{
			value: '06',
			label: '其他机动车贸易商'
		},
		{
			value: '07',
			label: '二手车市场'
		},
		{
			value: '08',
			label: '二手车经销企业'
		},
		{
			value: '09',
			label: '二手车拍卖企业'
		},
		{
			value: '10',
			label: '稀土矿产企业'
		},
		{
			value: '11',
			label: '稀土冶炼分离企业'
		},
		{
			value: '12',
			label: '稀土其他企业'
		},
		{
			value: '13',
			label: '稀土矿产企业、稀土冶炼分离企业、稀土其他企业'
		},
		{
			value: '14',
			label: '稀土矿产企业、稀土冶炼分离企业'
		},
		{
			value: '15',
			label: '稀土矿产企业、稀土其他企业'
		},
		{
			value: '16',
			label: '稀土冶炼分离企业、稀土其他企业'
		},
		{
			value: '17',
			label: '卷烟生产企业18：卷烟批发企业'
		},
		{
			value: '19',
			label: '卷烟出口企业'
		},
		{
			value: '20',
			label: '生产型出口企业'
		},
		{
			value: '21',
			label: '外贸型出口企业'
		},
		{
			value: '22',
			label: '外贸综合服务企业'
		},
		{
			value: '23',
			label: '自贸区试点企业'
		},
		{
			value: '24',
			label: '特殊监管区内企业'
		},
		{
			value: '25',
			label: '增值税一般纳税人资格试点'
		},
		{
			value: '26',
			label: '市场采购试点'
		},
		{
			value: '27',
			label: '退税商店'
		},
		{
			value: '28',
			label: '电子商务出口企业'
		},
		{
			value: '29',
			label: '享受出口退税政策的融资租赁企业'
		},
		{
			value: '30',
			label: '增值税零税率应税服务提供者'
		},
		{
			value: '31',
			label: '房地产开发企业'
		},
		{
			value: '32',
			label: '农产品深加工企业'
		},
		{
			value: '33',
			label: '外购石脑油、燃料油用于消费税退税企业'
		},
		{
			value: '34',
			label: '从事机动车进口的其他贸易商'
		},
		{
			value: '35',
			label: '自产农产品者'
		},
		{
			value: '36',
			label: '农产品收购企业'
		},
		{
			value: '37',
			label: '光伏收购企业'
		},
		{
			value: '38',
			label: '住房租赁企业'
		},
		{
			value: '39',
			label: '冬奥会退'
		}
	],
	ExciseTaxPayerType: [{
			value: '01',
			label: '卷烟生产消费税纳税人'
		},
		{
			value: '02',
			label: '卷烟批发消费税纳税人'
		},
		{
			value: '03',
			label: '白酒生产消费税纳税人'
		},
		{
			value: '04',
			label: '黄酒生产消费税纳税人'
		},
		{
			value: '05',
			label: '啤酒生产消费税纳税人'
		},
		{
			value: '06',
			label: '其他酒生产消费税纳税人'
		},
		{
			value: '07',
			label: '小汽车生产消费税纳税人'
		},
		{
			value: '08',
			label: '超豪华小汽车消费税纳税人'
		},
		{
			value: '09',
			label: '汽油生产消费税纳税人'
		},
		{
			value: '10',
			label: '石脑油生产消费税纳税人'
		},
		{
			value: '11',
			label: '溶剂油生产消费税纳税人'
		},
		{
			value: '12',
			label: '润滑油生产消费税纳税人'
		},
		{
			value: '13',
			label: '柴油生产消费税纳税人'
		},
		{
			value: '14',
			label: '航空煤油生产消费税纳税人'
		},
		{
			value: '15',
			label: '燃料油生产消费税纳税人'
		},
		{
			value: '16',
			label: '电池生产消费税纳税人'
		},
		{
			value: '17',
			label: '涂料生产消费税纳税人'
		},
		{
			value: '18',
			label: '高档化妆品生产消费税纳税人'
		},
		{
			value: '19',
			label: '金银首饰铂金首饰和钻石及钻石饰品零售消费税纳税人'
		},
		{
			value: '20',
			label: '其他贵重首饰和珠宝玉石生产消费税纳税人'
		},
		{
			value: '21',
			label: '鞭炮焰火生产消费税纳税人'
		},
		{
			value: '22',
			label: '摩托车生产消费税纳税人'
		},
		{
			value: '23',
			label: '高尔夫球及球具生产消费税纳税人'
		},
		{
			value: '24',
			label: '高档手表生产消费税纳税人'
		},
		{
			value: '25',
			label: '游艇生产消费税纳税人'
		},
		{
			value: '26',
			label: '木制一次性筷子生产消费税纳税人'
		},
		{
			value: '27',
			label: '实木地板生产消费税纳税人'
		},
		{
			value: '28',
			label: '雪茄烟生产消费税纳税人'
		},
		{
			value: '29',
			label: '烟丝生产消费税纳税人'
		},
	],
	RiskTaxpayerType: [{
		value: '',
		label: '非风险纳税人'
	}, {
		value: '01',
		label: 'Ⅰ类（高风险） 纳税人'
	}, {
		value: '02',
		label: 'Ⅱ类（中风险）纳税人'
	}, {
		value: '03',
		label: 'Ⅲ类（高风险） 纳税人'
	}, {
		value: '04',
		label: 'Ⅳ类（高风险） 纳税人'
	}, ],

	WarningLevel: [{
		value: '',
		label: '无预警',
		src: '',
		color: '#666666',
	}, {
		value: '01',
		label: '红色预警',
		src: 'reddanger.svg',
		color: '#E02020',
	}, {
		value: '02',
		label: '黄色预警',
		src: 'yellowdanger.svg',
		color: '#F29600',
	}, {
		value: '03',
		label: '蓝色预警',
		src: 'bluedanger.svg',
		color: '#0065B1',
	}, ]
}
